/* eslint-disable @typescript-eslint/no-explicit-any */

import {
  
  AfterViewInit,
  Component, ComponentRef, ElementRef, HostListener,
  Inject,Injector,OnDestroy, OnInit, PLATFORM_ID, ViewChild, ViewContainerRef
} from '@angular/core';
import { AppService } from './api.service';
import { SwUpdate } from '@angular/service-worker';
import { Observable, fromEvent, merge, of } from 'rxjs';
import { mapTo } from 'rxjs/operators';
import { isPlatformBrowser } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { DeviceDetectorService } from 'ngx-device-detector';
import * as uuid from 'uuid';
import { WindowService } from './services/window.service';
import { PopupService } from './services/popup.service';
import { LocalStorageService } from './services/localstorage.service';
import { RatingService } from './services/rating.service';
import { MessageService } from 'primeng/api';
import { ConnectPopupComponent } from './global/connect-popup/connect-popup.component';

import { NetworkStatusService } from './services/network-status.service';
import { trigger, state, style, transition, animate } from '@angular/animations';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  providers: [MessageService],
  animations: [
    trigger('visibilityChanged', [
      state('shown', style({ opacity: 1 })),
      state('hidden', style({ opacity: 0 })),
      transition('shown <=> hidden', animate('300ms ease-in-out'))
    ])
  ]
})
export class AppComponent implements OnInit,AfterViewInit,OnDestroy {
  title = 'afterbricks-v2';
  online$!: Observable<boolean>;
  onlineOffline = false;
  isOnMobilePlatform = false;
  ipAddress!: { ip: string };
  deviceInfo: any;
  isBrowser = false;
  page_loaded = false;
  enableAnimation = true; 
  @ViewChild('mainContent') mainContentDiv!: ElementRef<HTMLElement>;
  @ViewChild('popupContainer', { read: ViewContainerRef, static: true }) popupContainer!: ViewContainerRef;
  // @ViewChild('cashbackPopupContainer', { read: ViewContainerRef,}) cashbackPopupContainer!: ViewContainerRef;
 
  // @ViewChild('connectPopupContainer', { read: ViewContainerRef }) connectPopupContainer!: ViewContainerRef;
  // @ViewChild('sharePopupContainer', { read: ViewContainerRef }) sharePopupContainer!: ViewContainerRef;
  // @ViewChild('compareOfferPopupContainer', { read: ViewContainerRef }) compareOfferPopupContainer!: ViewContainerRef;
  // @ViewChild('ratingPopupContainer', { read: ViewContainerRef }) ratingPopupContainer!: ViewContainerRef;
  // @ViewChild('connectPopupContainer', { read: ViewContainerRef }) sharedCo!: ViewContainerRef;
  // @ViewChild('connectPopupContainer', { read: ViewContainerRef }) connectPopupContainer!: ViewContainerRef;

  componentRef!: ComponentRef<ConnectPopupComponent>;

  isOnline = true;
  isAppReady = false;
  PopupContainerModule!: typeof import("./global/popup-container/popup-container.module").PopupContainerModule;
  
  constructor(
    private _as: AppService,
    private deviceService: DeviceDetectorService,
    @Inject(PLATFORM_ID) private platformId: object,
    private window: WindowService,
    private http: HttpClient,
    private swUpdate: SwUpdate,
    public _pop: PopupService,
    private localStorageService: LocalStorageService,
    public ratingsService: RatingService,
    private networkStatusService: NetworkStatusService,
    private injector: Injector
  ) {
    this.isBrowser = isPlatformBrowser(this.platformId);

    if (this.isBrowser) {
      const win = this.window.nativeWindow;
    if (win) {
      this.isOnline = win.navigator.onLine;

      win.addEventListener('online', () => {
        this.isOnline = true;
      });

      win.addEventListener('offline', () => {
        this.isOnline = false;
      });
    }

      // Handle Service Worker Update
      if (this.swUpdate.isEnabled) {
        this.swUpdate.versionUpdates.subscribe((event) => {
          if (event.type === 'VERSION_READY') {
            this.promptUserForUpdate();
          }
        });
      }
    }
  }

  ngOnInit() {
    this.localStorageService.removeItem('appUpdated');

    if (this.isBrowser) {
      this.getIpCliente();
      this.deviceInfo = this.deviceService.getDeviceInfo();
    }
    this.networkStatusService.isOnline$.subscribe(status => {
      this.isOnline = status;
    });

    if (this.isBrowser) {
      setTimeout(() => {
        this.isAppReady = true;
      }, 500); // delay rendering of popups
    }
  }

  ngAfterViewInit() {
    // Dynamically import the GlobalModule after the app loads
    import('./global/popup-container/popup-container.module').then(module => {
      this.PopupContainerModule = module.PopupContainerModule;
      console.log('GlobalModule loaded dynamically');
    }).catch(err => {
      console.error('Failed to load GlobalModule', err);
    });
  }
  promptUserForUpdate() {
    const confirmed = window.confirm('New version available! Reload to update?');
    if (confirmed) {
      this.swUpdate.activateUpdate().then(() => {
        caches.keys().then((names) => {
          for (const name of names) caches.delete(name);
        }).finally(() => {
          document.location.reload();
        });
      });
    }
  }

  getIpCliente() {
    this.http.jsonp('https://jsonip.com?callback=JSONP_CALLBACK', 'callback')
      .subscribe((response: any) => {
        this.ipAddress = response.ip;
        this.guestUser();
      });
  }

  guestUser() {
    const myId = uuid.v4();
    let storedUuid = null;

    try {
      storedUuid = JSON.parse(this.localStorageService.getItem('uuid') || '');
    } catch {
      storedUuid = null;
    }

    if (!storedUuid) {
      this.deviceInfo = this.deviceService.getDeviceInfo();
      const data = {
        ip_address: this.ipAddress.ip,
        uuid: myId,
        device_type: this.deviceInfo.deviceType,
        browser: this.deviceInfo.browser,
        browser_version: this.deviceInfo.browser_version,
      };

      const url = this._as.api_base_url + 'renovarz/guest-user/';
      this._as.postRequest(url, data, true).subscribe((res: any) => {
        if (res) {
          this.localStorageService.setItem('uuid', JSON.stringify(myId));
        }
      });
    }
  }

  onActivate() {
    console.log("Route activated");
  }

  @HostListener('window:resize', ['$event'])
  onResize() {
    if (this.isBrowser) {
      const win = this.window.nativeWindow;
      this._as.isOnMobilePlatform = (win?.innerWidth ?? 0) <= 600;
    }
  }

  ngOnDestroy() {
    if (this.componentRef) {
      this.componentRef.destroy();
    }

  }
}
